module.exports = __webpack_public_path__ + "img/tailwindcss-icon.10832eda.svg";